import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Currancy } from '../svg/icons/icon';
import Contextapi from '../../context-api/createContext';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './Loader';
import { baseUrl } from '../../utils.jsx/baseUrl';


function Comchecks({ paymentLeft }) {
  const {
    setEditcomsflag,
    paymentFlag,
    setPaymentFlag,
    editcomchecks,
    editcomsflag,
    setComcheckData,
    comcheckData,
  } = useContext(Contextapi);

  const token = sessionStorage.getItem('token');
  const sid = sessionStorage.getItem('sid');

  const [loaderflag, setLoaderFlag] = useState(false);
  const [scheduleType, setScheduleType] = useState("");
  const [amount, setAmount] = useState(comcheckData?.amount || paymentLeft || "");

  // Sync amount when comcheckData or paymentLeft changes
  useEffect(() => {
    if (comcheckData?.amount !== undefined && comcheckData?.amount !== null) {
      setAmount(comcheckData.amount);
    } else {
      setAmount(paymentLeft || "");
    }
  }, [comcheckData, paymentLeft]);

  const handler = (e) => {
    const value = e.target.value;
    setAmount(value);
    setComcheckData({ ...comcheckData, [e.target.name]: value });
  };

  const handleBlur = () => {
    if (!amount) {
      setAmount(paymentLeft || "");
      setComcheckData({ ...comcheckData, amount: paymentLeft || "" });
    }
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!amount) {
      toast.warn('Please Enter Amount', { autoClose: 1500, pauseOnHover: false });
      return;
    }

    if (!scheduleType) {
      toast.error('Please select a schedule type', { autoClose: 2000 });
      return;
    }

    const url = `${baseUrl.url}/new-payment/add`;
    const body = {
      comchecks: {
        amount: Number(amount),
        scheduleType,
      },
      schedule_id: sid,
    };

    try {
      setLoaderFlag(true);
      const response = await axios.post(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoaderFlag(false);
      setScheduleType("");
      setComcheckData({ amount: '' });
      setAmount(paymentLeft || "");
      toast.success(response.data.message, { autoClose: 1500, pauseOnHover: false });
      setPaymentFlag(!paymentFlag);
    } catch (error) {
      setLoaderFlag(false);
      toast.warn(error?.response?.data?.error || 'Something went wrong', {
        autoClose: 1500,
        pauseOnHover: false,
      });
    }
  };

  const updateData = async (editcomchecksdata) => {
    try {
      const url = `${baseUrl.url}/new-payment/edit-payment/`;
      const body = {
        schedule_id: sid,
        pay_id: editcomchecksdata.id,
        payment_type: 'comchecks',
        data: {
          amount: Number(amount),
          id: editcomchecksdata.id,
          scheduleType,
        },
      };
      setLoaderFlag(true);
      const response = await axios.put(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setEditcomsflag(false);

      setLoaderFlag(false);
      setScheduleType("");
      setComcheckData([]);
      setAmount(paymentLeft || "");
      setPaymentFlag(!paymentFlag);
      toast.success('Payment Updated', { autoClose: 1000 });

       
    } catch (error) {
      setLoaderFlag(false);
      toast.warn(error?.response?.data?.error || 'Something went wrong', {
        autoClose: 1500,
      });
    }
  };

  // Sync scheduleType when editing
  useEffect(() => {
    if (comcheckData && comcheckData.scheduleType) {
      setScheduleType(comcheckData.scheduleType);
    }
  }, [comcheckData]);

  return (
    <>
      {loaderflag && <Loader />}
      <div className="w-full h-full">
        <div className="w-full h-[35px] border-b-[1px] border-b-gray-300 flex gap-[18px] items-center pb-[16px]">
          <div><Currancy /></div>
          <input
            onChange={handler}
            onBlur={handleBlur}
            type="number"
            value={amount}
            placeholder="Requested Amount"
            name="amount"
            className="w-full focus:outline-none placeholder:text-black placeholder:text-opacity-[0.4]"
          />
        </div>

        <div className="font-[400] text-base text-black mt-10">Processing Options</div>
        <div className="flex flex-row mt-4 gap-12 w-full">
          {['Express', 'Priority', 'Standard'].map((type) => (
            <div key={type} className="flex items-center gap-2">
              <input
                type="radio"
                name="scheduleType"
                value={type}
                checked={scheduleType === type}
                onChange={() => setScheduleType(type)}
              />
              <p className="font-normal text-base text-black">
                {type} {type === 'Express' && <span className='text-xs'>(~2 Hrs)</span>}
                {type === 'Priority' && <span className='text-xs'>(Same Day)</span>}
                {type === 'Standard' && <span className='text-xs'>(ACH)</span>}
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={editcomsflag ? () => updateData(editcomchecks) : submit}
          type="submit"
          className="mt-[41px] w-full h-[53px] flex justify-center items-center rounded-xl bg-[#258CFB] font-medium text-lg text-white"
        >
          {editcomsflag ? 'Update Payment Instruction' : 'Add Payment Instruction'}
        </button>
        <ToastContainer />
      </div>
    </>
  );
}



export default Comchecks;
